import React, { useEffect, useState } from "react";
import NurseScheduleHeader from "./widgets/schedule-header";
import MonthlyScheduler from "./widgets/monthly/MonthlyScheduler";
import NurseHeader from "../../../Components/layouts/header/nurse-header";
import { useSelector } from "react-redux";
import { RootState, store } from "../../../store/store";
import {
  setDate,
  setSelectedCalendar,
} from "../../../features/Time Slice/timeSlice";
import moment from "moment";
import WeeklyCalendar from "../../../Components/Calendar/weekly";
import NurseWeeklyActivities from "../week/widgets/weekly-calendar/NurseWeeklyActivities";
import WeekDaysTab from "../../../Components/Calendar/full-month-view/WeekDays";

const NurseScheduler = () => {
  const [dayNightFilter, setDayNightFilter] = useState<string>("All");
  // const month = [{ name: "November 2023" }, { name: "December 2023" }];
  const handleButtonClick = (button: string) => {
    setDayNightFilter(button);
  };

  // useEffect(() => {
  //   store.dispatch(setSelectedCalendar("month"));
  // }, []);

  const nextMonth = moment().add(1, "month");
  const [month, setMonth] = useState({
    name: nextMonth.format("MMMM"),
    monthName: nextMonth.format("MMMM"),
    label: nextMonth.format("M"),
  });

  const [year, setYear] = useState({
    name: nextMonth.format("YYYY"),
    year: nextMonth.format("YYYY"),
    label: "year",
  });
  const currentDate = moment();
  const currentWeek = Math.ceil(currentDate.date() / 7);

  const [week, setWeek] = useState({
    name: `Week ${currentWeek}`,
    weekLabel: "Week",
    label: currentWeek,
  });

  const selectedCalendar = useSelector(
    (state: RootState) => state.time.selectedCalendar
  );

  return (
    <>
      <div className="h-screen flex flex-col">
        <NurseHeader month={month} year={year} setMonth={setMonth} />
        <div className="flex-1 flex flex-col">
          <NurseScheduleHeader
            year={year}
            month={month}
            setYear={setYear}
            setMonth={setMonth}
            week={week}
            setWeek={setWeek}
          />
          {selectedCalendar === "month" ? (
            <div className="flex-1 min-h-0 flex flex-col">
              <WeekDaysTab month={month} year={year} />
              {/* Legend — mobile only */}
              <div className="md:hidden flex items-center gap-3 px-3 py-1 border-b border-beerus text-[10px] text-bulma flex-wrap">
                <span className="flex items-center gap-1"><span className="inline-flex items-center justify-center w-4 h-4 bg-krillin-10 text-krillin rounded text-[10px]">☀</span> Day</span>
                <span className="flex items-center gap-1"><span className="inline-flex items-center justify-center w-4 h-4 bg-beerus rounded text-[10px]">☽</span> Night</span>
                <span className="flex items-center gap-1"><span className="inline-flex items-center justify-center w-4 h-4 bg-krillin-10 rounded text-[10px]">⊙</span> Mid·Day</span>
                <span className="flex items-center gap-1"><span className="inline-flex items-center justify-center w-4 h-4 bg-beerus rounded text-[10px]">☽z</span> Mid·Night</span>
                <span className="flex items-center gap-1"><span className="inline-flex items-center justify-center w-4 h-4 bg-zinc-200 rounded text-[10px]">✕</span> Leave</span>
                <span className="flex items-center gap-1"><span className="inline-flex items-center justify-center w-4 h-4 bg-teal-50 text-teal-400 rounded text-[10px]">R</span> RO</span>
              </div>
              <div className="flex-1 min-h-0 overflow-y-auto">
                <MonthlyScheduler month={month} year={year} />
              </div>
            </div>
          ) : selectedCalendar === "week" ? (
            <div className="flex-1  flex flex-col">
              <NurseWeeklyActivities month={month} year={year} week={week} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default NurseScheduler;
